import { FC, memo, useContext } from 'react';
import { Icons } from 'src/assets/fonts/Icons/icons';
import { defaultIntegrationTooltipOptions } from 'src/constants/integrations';
import { defaulLangTextValidation, LOCALES } from 'src/constants/main';
import { localeStore } from 'src/mobx/localesStore';
import { ILangTextValidation, TTranslate } from 'src/types/main';
import { TOOLTIP_POSITION } from 'src/view/components/Controls/CustomTooltip/CustomTooltip';
import Icon from 'src/view/components/Controls/Icon/Icon';
import MultiLanguageInput from 'src/view/components/Controls/MultiLanguageInput/MultiLanguageInput';
import IntegrationManager from 'src/view/components/IntegrationManager/IntegrationManager';
import { RestrictionAccessContext } from 'src/view/containers/Modals/DineInSectionModal/DineInSectionModal';

interface IProps {
  id: number;
  name: TTranslate;
  validation: ILangTextValidation | undefined;
  showDeleteBtn?: boolean;
  onDelete: (id: number) => void;
  onChangeName: (tableId: number, value: string, locale: LOCALES) => void;
}

const TableListRow: FC<IProps> = ({ id, name, validation, showDeleteBtn, onDelete, onChangeName }) => {
  const { restrictionAccess, isDisabledForEditing } = useContext(RestrictionAccessContext);

  return (
    <div className="d-flex gap-20">
      <MultiLanguageInput
        arText={name.ar}
        enText={name.en}
        placeholder={localeStore.t('type_in_table_name')}
        wrapperClassName="full-width"
        className="full-width"
        validation={validation || { ...defaulLangTextValidation }}
        tooltip={isDisabledForEditing ? { ...defaultIntegrationTooltipOptions, position: TOOLTIP_POSITION.PORTAL } : undefined}
        disabled={isDisabledForEditing}
        onChangeValue={(value, locale) => onChangeName(id, value, locale)}
      />
      {showDeleteBtn && (
        <IntegrationManager
          setting={restrictionAccess}
          withTooltip
          tooltipOptions={{ show: isDisabledForEditing, minWidth: 355, position: TOOLTIP_POSITION.PORTAL }}>
          <Icon name={Icons.Trash} size={24} className="section-list-row__delete-btn my-2" onPress={() => onDelete(id)} />
        </IntegrationManager>
      )}
    </div>
  );
};

export default memo(TableListRow);
